import * as checkoutActions from '../../actions/checkout';
import * as audioVideoActions from '../../actions/checkout/audio-video';
import * as inmateActions from '../../actions/inmate';
import * as taxActions from '../../actions/tax';
import { IInmate } from '../../models/Inmate';
import { InmateAccountPayment, InmateAccountPaymentData } from '../../models/InmateAccountPayment';
import { ITaxAmountResponse } from '../../resources/Tax';
import { ApiError } from '../../services/api';

export interface ICheckoutAudioVideoState {
  inmateAni?: string
  loadingInmateByAni: boolean
  inmates?: IInmate[]
  inmatesLoading: boolean
  paymentData?: InmateAccountPaymentData
  payment?: InmateAccountPayment
  processing: boolean
  processingError?: ApiError
  fetchingTaxAmounts: boolean
  taxAmounts?: ITaxAmountResponse
}

const initialState:ICheckoutAudioVideoState = {
  processing: false,
  inmatesLoading: false,
  loadingInmateByAni: false,
  fetchingTaxAmounts: false
};

export function checkoutAudioVideoReducer(
  state: ICheckoutAudioVideoState = initialState,
  action: audioVideoActions.AudioVideoActionTypes | taxActions.TaxActionTypes | inmateActions.InmateActionTypes
  ): ICheckoutAudioVideoState {
  switch (action.type) {
    case checkoutActions.SELECT_FACILITY:
      return initialState;

    case checkoutActions.SELECT_SERVICE:
      return initialState;

    case audioVideoActions.LOADING_INMATE_BY_ANI:
      return {
        ...state,
        inmateAni: action.ani,
        loadingInmateByAni: true
      };

    case audioVideoActions.LOADED_INMATE_BY_ANI:
      return {
        ...state,
        inmateAni: action.ani,
        loadingInmateByAni: false
      };

    case audioVideoActions.CLEAR_INMATE_ANI:
      return {
        ...state,
        inmateAni: undefined,
        loadingInmateByAni: false
      };

    case audioVideoActions.SET_DETAILS:
      return {
        ...state,
        paymentData: action.details,
        loadingInmateByAni: false
      };

    case inmateActions.INMATES_LOADING:
      return {
        ...state,
        inmatesLoading: true,
        inmates: null
      };

    case inmateActions.INMATES_LOAD_FAILURE:
      return {
        ...state,
        inmatesLoading: false,
        inmates: null
      };

    case inmateActions.INMATES_LOAD_SUCCESS:
      const inmates: IInmate[] = action.inmates;
      return {
        ...state,
        inmatesLoading: false,
        inmates
      };

    case audioVideoActions.PAYMENT_PROCESSING:
      return {
        ...state,
        processing: true,
        processingError: null
      };

    case audioVideoActions.PAYMENT_FAILURE:
      return {
        ...state,
        processing: false,
        processingError: action.error
      };

    case audioVideoActions.PAYMENT_SUCCESS:
      return {
        ...state,
        payment: action.payment,
        processing: false
      };

    case audioVideoActions.RESET_SENSITIVE:
      return {
        ...state,
        payment: null,
        paymentData: {
          ...state.paymentData,
          cc: null
        }
      };

    case taxActions.AMOUNT_FETCHING:
      return {
        ...state,
        fetchingTaxAmounts: true,
        taxAmounts: null
      };

    case taxActions.AMOUNT_FETCHING_FAILURE:
      return {
        ...state,
        fetchingTaxAmounts: false
      };

    case taxActions.AMOUNT_FETCHING_SUCCESS:
      return {
        ...state,
        fetchingTaxAmounts: false,
        taxAmounts: action.amounts
      };

    case taxActions.AMOUNT_RESET:
      return {
        ...state,
        fetchingTaxAmounts: false,
        taxAmounts: null
      };

    case audioVideoActions.RESET:
      return initialState;
  }

  return state;
}
